<template>
  <div id="user-management">
    <div class="detail-management">
      <h2>DANH SÁCH KHÁCH HÀNG</h2>
      <div class="list-action-btn d-flex flex-row justify-content-between">
        <div class="search position-relative">
          <input
            type="text"
            placeholder="Tìm kiếm theo tên, số điện thoại, email..."
            class="form-control search-form"
            v-model="searchKeyword"
            @keydown.enter="triggerSearch()"
          />
          <img
            alt="1"
            @click="searchUserByKeyWord()"
            class="img-absolute"
            style="cursor: pointer"
            :src="require('@/assets/images/tabler_search.png')"
          />
        </div>
        <div class="list-button">
          <button
            class="common-btn mx-2"
            data-toggle="collapse"
            data-target="#collapseExample"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            Bộ lọc
            <img :src="require('@/assets/images/filter.png')" alt="2" />
          </button>
          <button class="common-btn mx-2" @click="refreshDataUserInfo()">
            Cập nhập
            <img
              alt="3"
              :class="{ rotate: isLoadingUserInfo }"
              :src="require('@/assets/images/refresh.png')"
            />
          </button>
          <button class="common-btn mx-2" v-b-modal.modal-1>
            Thêm KH
            <img :src="require('@/assets/images/user_add.png')" />
          </button>
        </div>
      </div>
      <div class="collapse mt-2" id="collapseExample">
        <div class="card card-body">
          <div class="filter-div">
            <div class="header-filter">BỘ LỌC</div>
            <div class="body-filter">
              <div class="filter-item first-name">
                <label for="first_name" class="form-label"
                  >Tên khách hàng</label
                >
                <input
                  type="input"
                  class="form-control"
                  id="first_name"
                  v-model="filterCustomerCondition.name"
                  required
                />
              </div>
              <div class="filter-item last-name">
                <label for="last_name" class="form-label">Tên công ty</label>
                <input
                  type="input"
                  class="form-control"
                  id="last_name"
                  v-model="filterCustomerCondition.company_name"
                  required
                />
              </div>
              <div class="filter-item phone-number">
                <label for="phone_number" class="form-label"
                  >Số điện thoại</label
                >
                <input
                  type="input"
                  class="form-control"
                  id="phone_number"
                  v-model="filterCustomerCondition.phone"
                  required
                />
              </div>
              <div class="filter-item email">
                <label for="email" class="form-label">Email</label>
                <input
                  type="input"
                  class="form-control"
                  id="email"
                  v-model="filterCustomerCondition.email"
                  required
                />
              </div>
              <div class="filter-item date">
                <label for="email" class="form-label">Ngày nhập</label>
                <b-form-select
                  v-model="filterCustomerCondition.from.month"
                  :options="listOptionMonth"
                ></b-form-select>
                <b-form-select
                  v-model="filterCustomerCondition.from.year"
                  :options="listOptionYear"
                  class="mt-3"
                ></b-form-select>
              </div>
              <div class="filter-item date">
                <label for="email" class="form-label"
                  >Đến {{ filterCustomerCondition.to.year }}</label
                >
                <b-form-select
                  v-model="filterCustomerCondition.to.month"
                  :options="listOptionMonth"
                ></b-form-select>
                <b-form-select
                  v-model="filterCustomerCondition.to.year"
                  :options="listOptionYear"
                  class="mt-3"
                ></b-form-select>
              </div>
              <div class="list-option-checkbox">
                <b-form-checkbox-group
                  id="checkbox-group-1"
                  class="list-checkbox"
                  v-model="filterCustomerCondition.statuses"
                  :options="STATUS_OPTIONS_CHECKBOX"
                  name="flavour-1"
                ></b-form-checkbox-group>
              </div>
              <div class="filter-item member-sale">
                <template v-if="this.isAdmin">
                  <label for="email" class="form-label"
                    >Nhân viên chăm sóc</label
                  >
                  <b-form-select
                    v-model="filterCustomerCondition.memberId"
                    :options="optionsMemberData"
                  ></b-form-select>
                </template>
              </div>
              <div class="filter-item-submit button_submit">
                <button
                  class="common-btn mx-2"
                  @click="getUserInfoSearch()"
                  data-toggle="collapse"
                  data-target="#collapseExample"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  Xác nhận
                </button>

                <button
                  class="clear-btn mx-2"
                  @click="clearFilter()"
                  data-toggle="collapse"
                  data-target="#collapseExample"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-data">
        <div class="header-table d-flex flex-row justify-content-between">
          <div class="header-item-data no-item"><span>STT</span></div>
          <div class="header-item-data user-item">
            <span>Tên khách hàng</span>
          </div>
          <div class="header-item-data phone-item">
            <span>Số điện thoại</span>
          </div>
          <div class="header-item-data email-item"><span>Email</span></div>
          <div class="header-item-data company-name">
            <span>Tên công ty / Ngành nghề</span>
          </div>
          <div class="header-item-data required-item flex-grow-1">
            <span>Nhu cầu</span>
          </div>
          <div class="header-item-data created_date">
            <span>Ngày nhập</span>
          </div>
          <div class="header-item-data updated_date">
            <span>CSKH gần nhất</span>
          </div>
          <div class="header-item-data list-member"><span>Nhân viên</span></div>
          <div class="header-item-data status-item">
            <span>Tình trạng</span>
          </div>
          <div class="header-item-data timeline"><span>Timeline</span></div>
          <div class="header-item-data note"><span>Ghi chú</span></div>
        </div>
        <div class="body-table d-flex flex-column">
          <div
            v-for="(record, idx) in listUserInfo"
            @contextmenu="handleMouseDown($event, record)"
            class="record-table d-flex flex-row justify-content-between"
            :key="idx"
            :class="{
              'bg-even-record': idx % 2 != 0,
              'bg-odd-record': idx % 2 == 0,
            }"
          >
            <div class="body-item-data no-item">
              <span>{{ idx + 1 }}</span>
            </div>
            <div
              class="body-item-data user-item"
              @click="handleCustomerNameClick($event, record)"
            >
              <span
                ><b>{{ record.name }}</b></span
              >
            </div>
            <div class="body-item-data phone-item">
              <span>{{ record.phone }}</span>
            </div>
            <div class="body-item-data email-item">
              <span>{{ record.email }}</span>
            </div>
            <div class="body-item-data company-name">
              <span>{{ record.company_name }}</span>
            </div>
            <div class="body-item-data required-item flex-grow-1">
              <span class="text-container">
                <template v-if="record?.demand?.expect_area">
                  {{ record?.demand?.expect_area }} -
                </template>
                <template v-if="record?.demand?.budget">
                  {{ record?.demand?.budget }} -
                </template>
                <template v-if="record?.demand?.address?.expect_location">
                  {{ record?.demand?.address?.expect_location }} -
                </template>
                <template v-if="record?.demand?.used_time">
                  {{ record?.demand?.used_time }} -
                </template>
                {{ record?.special_note }}
              </span>
            </div>
            <div class="body-item-data created_date">
              <span>{{ formatDate(record.member_create_customer_at) }}</span>
            </div>
            <div class="body-item-data updated_date">
              <span>{{ formatDate(record.customer_care_at) }}</span>
            </div>
            <div class="body-item-data list-member">
              <template v-for="(member, index) in record.member_infos">
                <div class="member-item" :key="index">
                  <span>{{ member.name }}</span>
                </div>
              </template>
            </div>
            <div class="body-item-data status-item">
              <template v-for="(member, index) in record.member_infos">
                <div class="member-item" :key="index">
                  <span>{{
                    getStatusName(member.connection_info.status)
                  }}</span>
                </div>
              </template>
            </div>
            <div class="body-item-data timeline">
              <span>{{ formatDate(record.status_updated_at) }}</span>
            </div>
            <div class="body-item-data note">
              <span>{{ record.note }}</span>
            </div>
          </div>
        </div>
      </div>
      <pagination
        class="mt-3"
        v-model="filterCustomerCondition.pagination.page"
        :per-page="filterCustomerCondition.pagination.limit"
        :records="totalUsers * this.filterCustomerCondition.pagination.limit"
        @paginate="myCallback"
      />
      <userInfoModal
        :userInfo="newUserInfo"
        @updateUserInfo="updateUserInfo"
        :listMemberSaleData="listMemberSale"
        :optionsMemberSaleData="optionsMemberSale"
        title="Tạo khách hàng"
      ></userInfoModal>
    </div>
  </div>
</template>

<script>
import userInfoModal from "@/components/common/UserInfoModal.vue";
import { requestAsync } from "@/requester/requestAsync";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      listUserInfo: [],
      totalUsers: 0,
      isLoadingUserInfo: false,
      // for filter
      filterCustomerCondition: {
        name: "",
        company_name: "",
        phone: "",
        email: "",
        memberId: "",
        from: {},
        to: {},
        statuses: [
          "NEW",
          "INACCESSIBLE",
          "QUOTE",
          "WATCHED",
          "NEGOTIATION",
          "PENDING",
        ],
        pagination: {
          limit: 10,
          order: "desc",
          page: 1,
        },
      },
      initialFilterCustomerCondition: {},
      STATUS_OPTIONS_CHECKBOX: [
        {
          text: "Mới",
          value: "NEW",
        },
        {
          text: "Khó tiếp cận",
          value: "INACCESSIBLE",
        },
        {
          text: "Báo giá",
          value: "QUOTE",
        },
        {
          text: "Đi xem",
          value: "WATCHED",
        },
        {
          text: "Thương lượng",
          value: "NEGOTIATION",
        },
        {
          text: "Tạm hoãn",
          value: "PENDING",
        },
        {
          text: "Thành công",
          value: "SUCCESS",
        },
        {
          text: "Thất bại",
          value: "FAIL",
        },
      ],
      newUserInfo: null,
      searchKeyword: null,
      listOptionMonth: [
        { value: 1, text: "Tháng 1" },
        { value: 2, text: "Tháng 2" },
        { value: 3, text: "Tháng 3" },
        { value: 4, text: "Tháng 4" },
        { value: 5, text: "Tháng 5" },
        { value: 6, text: "Tháng 6" },
        { value: 7, text: "Tháng 7" },
        { value: 8, text: "Tháng 8" },
        { value: 9, text: "Tháng 9" },
        { value: 10, text: "Tháng 10" },
        { value: 11, text: "Tháng 11" },
        { value: 12, text: "Tháng 12" },
      ],
      listOptionYear: Array.from({ length: 20 }, (_, i) => {
        const y = 2020 + i;
        return { value: Number(y), text: y };
      }),
      listMemberSale: [],
      optionsMemberSale: [],
      optionsMemberData: [],
    };
  },
  components: {
    userInfoModal,
  },
  computed: {
    ...mapGetters("customer", ["getMemberId", "isAdmin", "getMemberInfo"]),
    ...mapGetters("user", ["getFilterObj"]),
  },
  watch: {
    getFilterObj: {
      deep: true,
      immediate: true,
      handler: function () {
        this.filterCustomerCondition = JSON.parse(
          JSON.stringify(this.getFilterObj)
        );
      },
    },
  },
  methods: {
    ...mapMutations("user", ["setFilterObj"]),
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    initNewUserInfo() {
      let data = {
        company_name: "",
        connect_info: {
          fifth_step: null,
          first_step: "",
          fourth_step: "",
          second_step: "",
          third_step: "",
        },
        current_home: "",
        customer_care_at: moment().format("YYYY-MM-DD"),
        demand: {
          address: {
            city: "",
            district: "",
            expect_location: "",
          },
          budget: "",
          expect_area: "",
          num_person: "",
          used_time: "",
          vehicle: {
            car: "",
            motorbike: "",
          },
        },
        demand_v2: "",
        email: "",
        member_create_customer_at: moment().format("YYYY-MM-DD"),
        member_id: "",
        name: "",
        note: "",
        phone: "",
        status: "NEW",
        special_note: "",
        status_updated_at: moment().format("YYYY-MM-DD"),
      };
      this.$set(this, "newUserInfo", data);
    },
    getStatusName(status) {
      switch (true) {
        case status === "NEW":
          return "Mới";
        case status === "INACCESSIBLE":
          return "Khó tiếp cận";
        case status === "QUOTE":
          return "Báo giá";
        case status === "WATCHED":
          return "Đi xem";
        case status === "NEGOTIATION":
          return "Thương lượng";
        case status === "PENDING":
          return "Tạm hoãn";
        case status === "SUCCESS":
          return "Thành công";
        case status === "FAIL":
          return "Thất bại";
      }
    },
    clearFilter() {
      this.$set(
        this,
        "filterCustomerCondition",
        this.initialFilterCustomerCondition
      );
      this.setFilterObj(this.filterCustomerCondition);
      this.getUserInfoSearch();
    },
    refreshDataUserInfo() {
      this.isLoadingUserInfo = true;
      setTimeout(() => {
        this.getUserInfoSearch();
        this.isLoadingUserInfo = false;
      }, 1000);
    },
    handleMouseDown(event, user) {
      const url = `/user-info-detail/${user.id}`;
      if ((event.metaKey || event.ctrlKey) && event.button === 2) {
        event.preventDefault();
        window.open(url, "_blank", "noopener");
      }
    },
    handleCustomerNameClick(e, record) {
      const url = `/user-info-detail/${record.id}`;
      if (e.metaKey || e.ctrlKey) {
        window.open(url, "_blank", "noopener");
        // Do not redirect in current tab
        return;
      }
      // Normal left click: redirect in current tab
      this.$router.push(url);
    },
    processData(data) {
      console.log("data", data);
      var clone = JSON.parse(JSON.stringify(data));
      if (!clone.memberId) delete clone.memberId;
      if (!this.isAdmin) clone.memberId = this.getMemberInfo.id;
      return clone;
    },
    async getUserInfoSearch(page = 1) {
      this.filterCustomerCondition.pagination.page = page;
      this.setFilterObj(this.filterCustomerCondition);
      let clone = this.processData(this.filterCustomerCondition);
      let res = await requestAsync.post("customers/search", clone);
      if (res?.items) {
        this.listUserInfo = res?.items;
        this.totalUsers = res?.total;
      }
    },
    triggerSearch() {
      // Use $nextTick to ensure that searchKeyword is updated before calling searchUserByKeyWord
      this.$nextTick(() => {
        this.searchUserByKeyWord();
      });
    },
    async searchUserByKeyWord(page = 1) {
      this.filterCustomerCondition.pagination.page = page;
      let res = await requestAsync.get(
        `customers/search?keyword=${encodeURIComponent(
          this.searchKeyword
        )}&page=${page}&limit=50&order=desc`
      );
      if (res?.items) {
        this.listUserInfo = res?.items;
      }
    },
    myCallback: function (page) {
      this.getUserInfoSearch(page);
    },
    updateUserInfo(data) {
      console.log(data);
      this.initNewUserInfo();
      this.getUserInfoSearch();
    },
    async getMemberSalesInfo() {
      if (this.isAdmin) {
        let res = await requestAsync.get("members");
        if (res.items) {
          this.memberSales = res.items;
          res.items.forEach((item) => {
            item.updated_at = moment(item.updated_at).format("DD-MM-YYYY");
          });
          this.listMemberSale = JSON.parse(JSON.stringify(res.items));
          let filterMember = res.items
            .sort((a, b) => {
              return new Date(a.created_at) - new Date(b.created_at);
            })
            .filter((item) => item.role === "MEMBER");
          this.optionsMemberSale = filterMember.map((item) => item.name);
          this.optionsMemberData = filterMember.map((item) => {
            return {
              text: item.name,
              value: item.id,
            };
          });
        }
      } else {
        this.listMemberSale = JSON.parse(JSON.stringify([this.getMemberInfo]));
        if (this.listMemberSale.length < 1) return;
        let filterMember = this.listMemberSale
          .sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
          })
          .filter((item) => item.role === "MEMBER");
        this.optionsMemberSale = filterMember.map((item) => item.name);
        this.optionsMemberData = filterMember.map((item) => {
          return {
            text: item.name,
            value: item.id,
          };
        });
      }
      this.optionsMemberData.unshift({
        text: "Tất cả",
        value: "",
      });
    },
  },
  mounted() {
    // Select all paragraphs with the class VuePagination__count
    const paragraphs = document.querySelectorAll(".VuePagination__count");

    // Loop through each paragraph and remove it
    paragraphs.forEach((paragraph) => {
      paragraph.remove();
    });
  },
  created() {
    this.initNewUserInfo();
    this.getUserInfoSearch();
    this.getMemberSalesInfo();
    this.$set(
      this,
      "initialFilterCustomerCondition",
      this.filterCustomerCondition
    );
  },
};
</script>

<style lang="scss">
@import "@/assets/variable.scss";
#user-management {
  h2 {
    color: $primary-color !important;
  }
  .detail-management {
    padding: 15px 15px 20px;
  }
  .list-action-btn {
    margin-top: 20px;
    .list-button {
      display: flex;
      flex-direction: row;
    }
  }
  .img-absolute {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
  }
  .search-form {
    width: 50%;
    min-width: 400px;
    height: 100%;
  }
  // filter
  .filter-div {
    .header-filter {
      background: rgba($primary-color, 0.6);
      text-align: center;
      padding: 10px 0px;
      color: #fff;
      font-size: 18px;
    }
    .body-filter {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .filter-item {
        width: 30%;
        margin-top: 20px;
      }
      .custom-select {
        height: 36px;
      }
      .date {
        display: flex;
        flex-direction: column;
      }
      .member-sale {
        display: flex;
        flex-direction: column;
      }
      .list-option-checkbox {
        width: 30%;
        margin: 10px 0px 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        .list-checkbox {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          .custom-control {
            min-width: 50%;
          }
          .custom-control-input {
            margin-right: 20px;
          }
        }
      }
      .filter-item-submit {
        width: 30%;
        align-self: flex-end;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
      }
    }
  }
  // table data
  .table-data {
    font-size: 11px;
    margin-top: 15px;
    overflow-x: auto;
    word-wrap: break-word;
    position: relative;
    .header-table {
      position: sticky;
      top: 0;
      left: 0;
      background: #f27473;
      color: #fff;
      font-size: 14px;
      width: 100%;
      border-left: solid 1px $border-color;
      border-right: unset;
      .header-item-data {
        text-align: center;
        padding: 15px 3px;
        border: solid 1px $border-color;
        border-left: unset;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .list-member {
        padding: 15px 5px !important;
      }
    }
    .body-table {
      width: 100%; //dont know
      max-height: calc(100vh - 325px);
      .record-table {
        cursor: pointer;
        border-left: solid 1px $border-color;
      }
      .bg-even-record {
        background: #fff;
      }
      .bg-odd-record {
        background: rgba($primary-color, 0.15);
      }
      .body-item-data {
        text-align: center;
        padding: 12px 5px;
        border: solid 1px $border-color;
        border-left: unset;
        border-top: unset;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          display: block;
          word-break: break-word;
        }
      }
    }
    .no-item {
      width: 35px;
      flex: 0 0 35px;
    }
    .phone-item {
      width: 100px;
      flex: 0 0 100px;
    }
    .user-item {
      font-size: 12px;
      width: 135px;
      flex: 0 0 135px;
    }
    .email-item {
      width: 150px;
      flex: 0 0 150px;
    }
    .required-item {
      flex: 1 1 auto; /* Cho phép phần tử này co giãn để chiếm không gian còn lại */
      min-width: 0;
      .text-container {
        word-wrap: break-word; /* Cho phép văn bản xuống dòng khi cần thiết */
        overflow-wrap: break-word; /* Tương tự như word-wrap, hỗ trợ nhiều trình duyệt */
        white-space: normal; /* Cho phép văn bản xuống dòng theo cách thông thường */
      }
    }
    .created_date,
    .updated_date,
    .status-item {
      width: 80px;
      flex: 0 0 80px;
    }
    .list-member {
      width: 140px;
      flex: 0 0 140px;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .status-item {
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .member-item {
      padding: 5px;
      width: 100%;
      &:not(:last-child) {
        border-bottom: solid 1px black;
      }
    }
    .company-name {
      width: 130px;
      flex: 0 0 130px;
    }
    .timeline {
      width: 70px;
      flex: 0 0 70px;
    }
    .note {
      width: 150px;
      flex: 0 0 150px;
    }
  }

  // pagination
  .page-link {
    color: $primary-color !important;
  }
  .disabled > .page-link {
    background: rgba($primary-color, 0.15) !important;
  }
  .active > .page-link,
  .page-link.active {
    background: $primary-color !important;
    color: #fff !important;
    border-color: $primary-color !important;
  }
  // rotate
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .rotate {
    animation: rotate 2s linear infinite; /* Rotate animation lasts for 3 seconds, linear timing, and repeats infinitely */
  }
}
</style>
